export default __webpack_public_path__ + "static/media/landpage.8ad8742e.jpeg";